import { render, staticRenderFns } from "./curso-preguntas.vue?vue&type=template&id=63ba1c56&scoped=true&"
import script from "./curso-preguntas.vue?vue&type=script&lang=ts&"
export * from "./curso-preguntas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba1c56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VWindow,VWindowItem})
